<!-- Signup Form Card -->
<div class="signup-card w-full !py-0 [&>.p-card-body]:!py-0">
  <div class="mb-3">
    <h2 class="text-2xl lg:text-3xl font-semibold text-gray-800 headerStyling">
      {{ i18n.t('tellUsAboutYourBusiness') }}
    </h2>
    <p class="business-sub-header">
      {{ i18n.t('withABusinessDetails') }}
    </p>
  </div>

  <form [formGroup]="BusinessDetailsForm" class="flex flex-col space-y-4 min-h-[500px] mt-5">
    <!-- Business Name -->
    <app-input formControlName="businessName" labelCustomClass="block mb-1 font-medium text-gray-700 labelInputClass"
      inputCustomClass="border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 px-2 py-0.5 rounded-md h-[45px] w-full labelInputClass"
      [label]="i18n.t('businessName')" [placeholder]="i18n.t('enterYourBusinessName')" [submitted]="submitted"></app-input>

    <!-- Business Location -->
    <app-dropdown [label]="i18n.t('businessLocation')" formControlName="businessLocation" [options]="businessLocation"
      optionLabel="name" optionValue="id" [placeholder]="i18n.t('select')"
      labelCustomClass="block mb-1 font-medium text-gray-700 labelInputClass"
      inputCustomClass="border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 px-2 py-0.5 rounded-md h-[45px] w-full labelInputClass"
      showClear="true" [submitted]="submitted" [filter]=true [isVirtualScroll]="true">
      <ng-template #selectedItem let-country>
        <div class="flex items-center gap-2">
          <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
            [class]="'flag flag-' + country.code?.toLowerCase()" style="width: 18px" />
          <div>{{ country.name }}</div>
        </div>
      </ng-template>
      <ng-template #item let-country>
        <div class="flex items-center gap-2">
          <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
            [class]="'flag flag-' + country.code?.toLowerCase()" style="width: 18px" />
          <div>{{ country.name }}</div>
        </div>
      </ng-template>
    </app-dropdown>

    <!-- Business Type -->
    <app-dropdown [label]="i18n.t('businessType')" formControlName="businessTier" [options]="groupedTierList" optionLabel="name"
      optionValue="id" [placeholder]="i18n.t('select')" labelCustomClass="block mb-1 font-medium text-gray-700 labelInputClass"
      inputCustomClass="border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 px-2 py-0.5 rounded-md h-[45px] w-full labelInputClass"
      showClear="true" [submitted]="submitted" [filter]=true [isVirtualScroll]="true" [group]="true"></app-dropdown>

    <div class="flex gap-4">
      <!-- Language -->
      <app-dropdown [label]="i18n.t('language')" formControlName="language" [options]="languages" optionLabel="value"
        optionValue="code" [submitted]="submitted" [placeholder]="i18n.t('select')" class="w-2/5"
        labelCustomClass="block mb-1 font-medium text-gray-700 labelInputClass"
        inputCustomClass="border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 px-2 py-0.5 rounded-md h-[45px] w-full labelInputClass"
        showClear="true" [filter]=true [isVirtualScroll]="true"></app-dropdown>

      <!-- Timezone -->
      <app-dropdown [label]="i18n.t('timezone')" formControlName="timezone" [options]="timezones" optionLabel="value"
        optionValue="code" [submitted]="submitted" [placeholder]="i18n.t('select')" class="w-3/5"
        labelCustomClass="block mb-1 font-medium text-gray-700 labelInputClass"
        inputCustomClass="border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 px-2 py-0.5 rounded-md h-[45px] w-full labelInputClass"
        showClear="true" [filter]=true [isVirtualScroll]="true"></app-dropdown>
    </div>

    <!-- Employee Count -->
    <app-input type="phone" formControlName="employeeCount" [label]="i18n.t('howManyEmployeesDoYouHave')"
      [submitted]="submitted" labelCustomClass="block mb-1 font-medium text-gray-700 labelInputClass"
      inputCustomClass="border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 px-2 py-0.5 rounded-md h-[45px] w-full labelInputClass"></app-input>

    <!-- Agreement Checkbox -->
    <app-checkbox [options]="checkboxOptions" formControlName="agreement" [submitted]="submitted"
      checkboxCustomClass="text-sm text-gray-600 tracking-tight"></app-checkbox>

    <!-- Button row -->
    <div class="mt-auto pt-4 flex grid grid-cols-2 justify-between items-center gap-4">
      <app-button [label]="i18n.t('previous')" type="button" severity="secondary" size="large"
        customClass="w-full flex-shrink-0 px-5 py-3" (clicked)="onPreviousClick()"></app-button>

      <app-button [label]="i18n.t('createAccount')" type="button" (click)="openTeamDetails()" severity="info" size="large"
        customClass="w-full flex-shrink-0 px-6 py-3 custom-dark-blue"></app-button>
    </div>
  </form>
</div>